module.exports = __webpack_public_path__ + "static/media/sen.9e8b1c03.png";